// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataxaut } from "../../../icons/mono/build/icon-stataxaut.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataxautIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataxaut.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataxautIcon.displayName = 'StataxautIcon';
}

export default StataxautIcon;